// Global vars
var pym = require("./lib/pym");
require("./lib/webfonts");
var dateFormatter = require("./dateFormatter");
var d3 = {
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
};
var { fmtComma } = require("./lib/helpers");

// var { getTimeStamp, arrayToObject, getData, updateTime } = require("./util");
var pymChild;

var renderBarChart = require("./renderBars");

var HOUSE_URL = "https://apps.npr.org/election-results-live-2022/data/house.json";
var SENATE_URL = "https://apps.npr.org/election-results-live-2022/data/senate.json";
var timestamps = [];

// Initialize the graphic.
var onWindowLoaded = function() {
  var dataHouse = getData(HOUSE_URL, "house");
  var dataSenate = getData(SENATE_URL, "senate");

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

var getData = async function(source, chamber) {
  var response = await fetch(source, { cache: "no-cache" });
  var json = await response.json();
  var resultsNotCalled = json.results.filter(function(d) {
    if (!d.called) {
      d.marginVote = d.candidates[0].votes - d.candidates[1].votes;
      d.marginPct = d.candidates[0].percent - d.candidates[1].percent;
    }
    return !d.called;
  });
  resultsNotCalled.sort(sortBy("marginVote"));

  var latest = Math.max(...resultsNotCalled.map((r) => r.updated));
  timestamps.push(latest);

  renderTable({
    chamber: chamber,
    data: resultsNotCalled
  })

  return resultsNotCalled;
}

// via https://www.measurethat.net/Benchmarks/Show/4167/0/vanilla-vs-lo-dash-vs-underscore-sortby
var sortBy = (key) => {
  return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
};

// Render the tables
var renderTable = function(config) {
  var container = d3.select("#" + config.chamber + "-table");

  // Find the biggest value
  let minVal = 0;
  let maxVal = 0;
  config.data.forEach(d => {
    if (d.marginVote > maxVal) {
      maxVal = d.marginVote
    }
  });
  var roundedMax = Math.round(maxVal/1000)*1000;
  roundedMax = (roundedMax / 1000).toFixed(0) + "k";

  // add timestamp if we've processed both datafiles
  if (timestamps.length == 2) {
    var latest = Math.max(...timestamps.map((r) => r));
    d3.select("#timestamp")
      .html(dateFormatter(latest));
  }

  // add counts to the table header
  d3.select("#" + config.chamber + "-count")
    .text(`(${ config.data.length })`);

  config.data.forEach((race, i) => {
    // vars
    var raceName = "";
    switch(race.office) {
      case "H":
        raceName = race.stateAP + " " + race.seat.replace(" ","&nbsp;");
        break;
        case "S":
          raceName = race.stateName;
          break;
    }
    var pctIn = `Estimate: ${ Math.round(race.eevp * 100) }%&nbsp;in`;
    var note = NOTES.find(n => n.id == race.id);
    var barWidth = (race.marginVote / maxVal) * 100;
    var marginPct = Math.round(race.marginPct * 10000) / 100;

    var row = container.append("div")
      .attr("class", function() {
        var leadingParty = race.candidates[0].party;
        var eevp90 = race.eevp >= 0.9 ? "over-90" : "";
        return `row ${ leadingParty } ${ eevp90 }`;
      })

    var rowLabel = row.append("div")
      .classed("label-wrapper", true)
      .append("div");
    rowLabel.append("a")
      .attr("href", `https://apps.npr.org/election-results-live-2022/#/states/${ race.state }/${ race.office }`)
      .append("span")
        .classed("race", true)
        .html(raceName);
    rowLabel.append("span")
      .classed("eevp", true)
      .html(pctIn);

    var bar = row.append("div")
      .classed("bar-wrapper", true);
    if (i == 0) {
      var scale = bar.append("div")
        .attr("class", `scale ${ config.chamber }`);
      scale.append("div")
        .classed("min", true)
        .text(minVal);
      scale.append("div")
        .classed("max", true)
        .text(roundedMax);
    }
    bar.append("div")
      .classed("bar-bg", true)
      .append("div")
        .classed("bar", true)
        .attr("style", `width: ${ barWidth }%`);

    var summary = row.append("div")
      .classed("summary-wrapper", true)
      .append("div")
        .html(function() {
          var candidate0 = race.candidates[0];
          var candidate1 = race.candidates[1];

          var incumbent0 = candidate0.incumbent ? "Incumbent " : "";
          var incumbent1 = candidate1.incumbent ? "Incumbent " : "";

          var summaryText = `${ incumbent0 }<span class="leader">${ candidate0.first } ${ candidate0.last } (${ candidate0.party })</span> leads ${ incumbent1 }<span class="name-2">${ candidate1.first } ${ candidate1.last } (${ candidate1.party })</span> by <span class="num-votes">${ fmtComma(race.marginVote) } votes</span>, or ${ marginPct } percentage points.`;

          if (note) {
            summaryText += ` ${ note.note }`;
          }

          return summaryText;
        })
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
window.onload = onWindowLoaded;
